import React from 'react'
import { withRouter } from 'react-router-dom'

import './style.scss'

@withRouter
class PublicLayout extends React.PureComponent {
  render() {
    const { children } = this.props
    return <div className="public-layout">{children}</div>
  }
}

export default PublicLayout
